// extracted by mini-css-extract-plugin
export var radioInputRow = "w_sc";
export var radioInputColumn = "w_sd";
export var inputOptionRow = "w_qq";
export var inputOptionColumn = "w_qr";